"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePattern = exports.setPattern = exports.REMOVE_PATTERN = exports.SET_PATTERN = exports.PATTERN = void 0;
exports.PATTERN = '[Pattern]';
exports.SET_PATTERN = 'SET_PATTERN';
exports.REMOVE_PATTERN = 'REMOVE_PATTERN';
const setPattern = ({ patternVehicleId }) => ({
    type: exports.SET_PATTERN,
    payload: patternVehicleId,
    meta: { feature: exports.PATTERN },
});
exports.setPattern = setPattern;
const removePattern = () => ({
    type: exports.REMOVE_PATTERN,
    payload: '',
    meta: { feature: exports.PATTERN },
});
exports.removePattern = removePattern;
//# sourceMappingURL=pattern.js.map